import { put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { getPackageId } from '../../selectors/package';
import { packageUpsaleOptionsStateTypeDTO } from './dto';

import {
  fetchSuccess,
  fetchError,
  clearOptions,
  setOptions,
  uncheckOption,
} from './slice';

import { api } from '../../../../../api';
import { FETCH_PACKAGE_UPSALE_OPTIONS_ACTION_TYPE } from './constants';
import type { fetchPackageUpsaleOptionsAction } from './actions';
import { prebuildOrderAction } from '../../actions/order';

function* fetchOptions(
  action: ReturnType<typeof fetchPackageUpsaleOptionsAction>,
) {
  try {
    const packageId = yield select(getPackageId);
    const flightPairId = action.payload;

    const upsaleOptions = yield api.getPackagesUpsaleOptions({
      package_id: packageId,
      flight_pair_id: flightPairId,
    });

    const parseData = packageUpsaleOptionsStateTypeDTO(upsaleOptions);

    yield put(clearOptions()); // Очищаем значения выбранных ранее доп услуг
    yield put(fetchSuccess(parseData));
  } catch (e) {
    yield put(fetchError());
  }
}

function* handleUpsaleOptionsChanged() {
  yield put(prebuildOrderAction());
}

function* saga() {
  yield takeEvery(FETCH_PACKAGE_UPSALE_OPTIONS_ACTION_TYPE, fetchOptions);
  yield takeLatest(
    [setOptions.type, uncheckOption.type],
    handleUpsaleOptionsChanged,
  );
}

export default saga;
